import React from 'react';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import ChangePasswordForm from '../components/ChangePasswordForm/ChangePasswordForm';

/**
 * Renders the change password view
 * Users are required to change their password before accessing the dashboard
 * @returns
 */
function ChangePassword() {
  return (
    <AuthCard>
      <AuthFormHeader />
      <ChangePasswordForm />
    </AuthCard>
  );
}

export default ChangePassword;
